/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 16:29:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-16 13:53:56
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/hooks.ts
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  currentSelectedStyle,
  fetchSalesChannelSpecificStyles,
  //fetchSalesChannelAvailableStyles,
} from 'src/constrains/SalesChannelStyleSelect/slice';
import emit from 'src/tools/event';
import { urlParamsKey } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { NEW, NULL } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

const useAfterDidMountStyleChanged = (func) => {
  const language = useSelector(currentSelectedStyle());
  useAfterDidMountEffect(() => {
    if (func) func();
  }, [language]);
};

const eForceUpdate = (uuid?) => {
  emit.emit(EnumAction.pageStyleListReload, uuid);
};

enum EnumAction {
  same = 'same',
  changed = 'changed',
  pageStyleListReload = 'pageStyleListReload',
}
// {
//   contentUuid,
//   type,
//   salesChannelUuid,
// }

const useQueryStyleListContentEditor = () => {
  const style = useSelector(currentSelectedStyle());
  return style;
};

const useGetPageStyleList = (multiProps) => {
  const p: any = useParams();
  const { isStyleRequired } = multiProps;
  // console.log('isStyleRequired', isStyleRequired);
  const d = useDispatch();
  //const { saleChannelUuid } = multiProps;
  const getList = (_uuid?) => {
    if (!multiProps) {
      return;
    } else {
      const { type, reduxAccessKeys = [], saleChannelUuid } = multiProps || {};
      const uuidKey = urlParamsKey[type || ''] || '';
      const isNew = p[uuidKey] == NEW || p[uuidKey] == NULL;
      const uuid = _uuid || (isNew ? '' : p[uuidKey] || '');
      // console.log('aa', {
      //   body: {
      //     type,
      //     uuid,
      //     salesChannelUuid: saleChannelUuid,
      //   },
      //   salesChannelUuid: saleChannelUuid,
      //   uuid,
      //   reduxAccessKeys,
      // });
      // console.log('uuidKey', uuidKey);
      // console.log('uuid', uuid);
      if (uuid) {
        d(
          fetchSalesChannelSpecificStyles({
            body: {
              type,
              uuid,
              salesChannelUuid: saleChannelUuid,
            },
            salesChannelUuid: saleChannelUuid,
            uuid,
            reduxAccessKeys,
          }),
        );
      } else {
        // d(
        //   fetchSalesChannelAvailableStyles({
        //     salesChannelUuid: saleChannelUuid,
        //   }),
        // );
      }
    }
  };
  const uuidGetList = (uuid) => {
    if (isStyleRequired) getList(uuid);
  };

  React.useEffect(() => {
    getList();
    if (isStyleRequired) {
      emit.on(EnumAction.pageStyleListReload, uuidGetList);
    }
    return () => {
      emit.removeListener(EnumAction.pageStyleListReload, uuidGetList);
    };
  }, []);
};

export default useGetPageStyleList;

export {
  EnumAction,
  eForceUpdate,
  useAfterDidMountStyleChanged,
  useGetPageStyleList,
  useQueryStyleListContentEditor,
};
